import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PromocodeBanner } from '../types';
import { PromocodeBannerState } from './promocode-banner.reducer';

export const getPromocodeBannerState =
  createFeatureSelector<PromocodeBannerState>('promocodeBanner');

export const getPromocodeBanners = createSelector(
  getPromocodeBannerState,
  (state: PromocodeBannerState) => state.promocodeBanners,
);

export const getPromocodeBanner = createSelector(
  getPromocodeBanners,
  (promocodeBanners) => {
    if (promocodeBanners.length > 0) {
      return promocodeBanners.reduce((prev, curr) =>
        getBannerWithHighestPriority(prev, curr) ? prev : curr,
      );
    }
  },
);

const getBannerWithHighestPriority = (
  prev: PromocodeBanner,
  curr: PromocodeBanner,
): boolean => {
  // Logic to select single banner out of the whole list:
  // Select the banner with lowest ranking (lower ranking index means higher priority)
  // If 2 or more banners has same ranking, then select the banner with latest created date
  if (prev.promoCodeRanking === curr.promoCodeRanking) {
    return (
      new Date(prev.promoCodeCreatedAt) > new Date(curr.promoCodeCreatedAt)
    );
  }
  return prev.promoCodeRanking < curr.promoCodeRanking;
};
